import Carousel from './Carousel'
import CarouselRatings from './CarouselRatings.vue'
import CarouselProducts from './CarouselProducts.vue'

export default {
  'carousel-banners': Carousel,
  'carousel-ratings': CarouselRatings,
  'carousel-products': CarouselProducts
}
